import { useQuery } from '@tanstack/react-query'
import { useAuth } from 'src/contexts/auth'
import { AnimalController } from 'src/controllers/animal.controller'

const animalController = new AnimalController()

export function useGetAnimalImage(animalId?: string) {
  const { userFarm: farmId } = useAuth()

  return useQuery<Blob | null, Error>({
    queryKey: ['getAnimalImage', farmId, animalId],
    queryFn: () => (animalId ? animalController.getAnimalImage(farmId!, animalId) : null),
    enabled: !!farmId && !!animalId
  })
}
